module.exports = __webpack_public_path__ + "img/new-guide-03-3.1070a2fa.png";